import { render, staticRenderFns } from "./WorkshopGroupUserList.vue?vue&type=template&id=3c117e10&scoped=true&"
import script from "./WorkshopGroupUserList.vue?vue&type=script&lang=js&"
export * from "./WorkshopGroupUserList.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopGroupUserList.vue?vue&type=style&index=0&id=3c117e10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c117e10",
  null
  
)

export default component.exports